<template>
    <div class="bg_blue">
        <div class="container_wrap">
            <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
                       <el-breadcrumb-item :to="{ path: '/indexpc'}">首页</el-breadcrumb-item>

                <el-breadcrumb-item> 国际交流</el-breadcrumb-item>
            </el-breadcrumb>
            <el-alert title="温馨提示" type="error" class="elalert">
                1.请先登陆单位会员帐号或注册（注意只对机构单位会员，个人会员无法报名）<br />
            </el-alert>

            <el-collapse v-model="activeNames"  class="elcollapse">
                <el-collapse-item :title="group.name"  v-for="(group,index) in groupList" :key="index" :name="index">
                    <div class="elcollapse_group_desc">{{group.desc}}</div>
                    <div>
                        <div  v-for="(item,vindex) in group.list" :key="vindex" class="apply_and_name">
                            <p>{{item.name}}</p>
                            <div class="apply_but">
                                <el-button type="primary" @click="goApply(item)">立即报名</el-button>
                            </div>
                        </div>

                    </div>
                </el-collapse-item>
            </el-collapse>

            <el-dialog title="提示信息" :visible.sync="dialogVisible">
                <el-tabs v-model="activeName">
                    <el-tab-pane label="报名须知" name="1">
                        <p>
                            1.本考级是由EAE主办的全国艺术导师等级的官方考试，面向艺术教育工作者和在校大学生，从铜牌艺术导师、银牌艺术导师、金牌艺术导师、钻石艺术导师、国际艺术导师，共分五级。
                        </p>
                        <p>
                            2.正确填写考级报名表后，并完成缴费，在报名结果中提示“报名成功”，出现问题，请及时与“在线客服”联系。
                        </p>
                        <p>
                            3.本考级采用线下与线上相结合的方式。报名后既可参加由EAE授权的各省和横店影视城的集中培训，也可以免费自学本网站的开放课程，然后上线参加理论和实践考试。
                        </p>
                        <p>
                            4.考级原则从铜牌艺术导师开始；具备高校专业课讲师可以从金牌导师考起，具备高级职称的专业课教师可以从钻石导师考起。必须逐级参考。
                        </p>
                        <p>
                            5.从铜牌导师开始，可以同时参加“全国艺术表演评委”考试；获得金牌以上艺术导师时，同时自动获得“全国艺术表演评委”，全国艺术表演评委既可以获得艺术展演的评委资格，也兼备“少儿艺术表演考级”的评委资格。
                        </p>
                        <p>6.从铜牌导师开始，将自动进入EAE艺术导师人才库。</p>
                        <p>
                            7.报考金牌导师以上，将集中由EAE线下培训与面考，理论测试仍在线上。
                        </p>
                    </el-tab-pane>
                    <el-tab-pane label="课程计划" name="2">课程计划</el-tab-pane>
                    <el-tab-pane label="考级培训" name="3">考级培训</el-tab-pane>
                    <el-tab-pane label="收费标准" name="4">收费标准</el-tab-pane>
                </el-tabs>

                <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">关闭</el-button>
          <el-button type="primary" @click="goApply()"
          >立即报名</el-button
          >
        </span>
            </el-dialog>
        </div>
    </div>
</template>
<script>
    import Vue from "vue";
    import NewsListItem from "@/components/listItem/NewsListItem";
    import { CountDown } from "vant";

    Vue.use(CountDown);

    export default {
        name: "CmsDetail",
        data() {
            return {
                dialogVisible: false,
                activeName: "1",
                type:'',
                activeNames:[
                    0,1,2,3
                ],
                row: {
                    id: 0,
                    current_index: 0,
                    user: {},
                    kaoji: {},
                },
                groupList:[

                ]
            };
        },
        components: {
            NewsListItem,
        },
        computed: {},
        mounted() {
            let that = this;
            that.fetch();
        },
        methods: {
            fetch(){
                let that = this;
                that.$api.post("/api/guoji/groupList", {
                }, (r) => {
                    that.groupList = r.data;
                },(r) =>{
                    that.$message.error(r.msg); 
                });
            },
            goApply(item){
                this.$router.push({
                    name:'GuojiApplyStep1',
                    query:{
                        saiqu_id:item.id
                    }
                })
            }
        },
    };
</script>
<style scoped lang="scss">
/deep/.elcollapse{
  .el-collapse-item{
    .el-collapse-item__header{
      padding-left: 15px;
      .el-collapse-item__arrow{
        margin: 0 80px 0 auto;
      }
    }
    .el-collapse-item__wrap{
        padding-left: 15px;
        .apply_and_name{
            padding-bottom: 20px;
        }
    }
  }
  .elcollapse_group_desc{
      color: #666;
  }
  .apply_and_name{
      display: flex;
      flex-direction: row;
      align-items: center;
      p{
          flex: 2;
          font-size: 20px;
        font-weight: bold;
        white-space: nowrap;
        overflow: hidden; 
        text-overflow: ellipsis;
      }
      .apply_but{
          flex: 1;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
      }

  }
}
    .status-1 {
        background: #559f07;
        color: #fff;
    }
    .status-2 {
        background: #e02020;
        color: #fff;
    }
    .status-0 {
        background: #f4faff;
        color: #666666;
    }
    .bg_blue {
        width: 100%;
        background: #f4faff;
        height: 100%;
        overflow: hidden;
    }
    .container_wrap {
        width: 1240px;
        margin: 0 auto;
        min-height: 1235px;
    }
    .breadcrumb {
        margin-top: 21px;
        margin-left: 23px;
        margin: 21px 0 20px 23px;
    }
    .elalert {
        margin: 0 0 40px 0;
    }
    .left_and_right_container {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        .container_list_item {
            width: 610px;
            height: 460px;
            background: #fdfdfd;
            box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
            border-radius: 68px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            .item_pic {
                width: 92px;
                height: 106px;
                background: url("~@/assets/images/listitem/编组 4@2x.png") no-repeat
                center center;
                background-size: 100% 100%;
            }
            .item_title {
                height: 25px;
                font-size: 18px;
                font-family: "Euclid Flex Bold",Arial,"PingFang SC",Verdana,"\5FAE\8F6F\96C5\9ED1";
                font-weight: 500;
                color: #333333;
                line-height: 25px;
                margin: 24px 0 0 0;
            }
            .item_but_up {
                margin: 40px 0 24px 0;

                /deep/.el-button {
                    font-size: 14px;
                    font-family: "Euclid Flex Bold",Arial,"PingFang SC",Verdana,"\5FAE\8F6F\96C5\9ED1";
                    font-weight: 500;
                    background: #d3ebff;
                    width: 229px;
                    height: 44px;
                    color: #333333;
                    border: none;
                    &:hover {
                        opacity: 0.9;
                        font-weight: bold;
                    }
                }
            }
            .item_but_down {
                /deep/.el-button {
                    font-size: 14px;
                    font-family: "Euclid Flex Bold",Arial,"PingFang SC",Verdana,"\5FAE\8F6F\96C5\9ED1";
                    font-weight: 500;
                    background: #0091ff;
                    width: 229px;
                    height: 44px;
                    border: none;
                    border-radius: 22px;
                    &:hover {
                        opacity: 0.9;
                        font-weight: bold;
                    }
                }
            }
            &:nth-child(2) {
                .item_pic {
                    background: url("~@/assets/images/listitem/形状@2x.png") no-repeat
                    center center;
                    background-size: 100% 100%;
                }
                .item_but_up {
                    margin: 40px 0 24px 0;
                    /deep/.el-button {
                        background: #ffc79f;
                    }
                }
                .item_but_down {
                    /deep/.el-button {
                        background: #fa6400;
                    }
                }
            }
        }

        // .container_left {
        //   width: 212px;
        //   height: 560px;
        //   background: #ffffff;
        //   box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
        //   border-radius: 32px;
        // }
        // .container_center {
        //   width: 716px;
        //   height: 560px;
        //   background: #ffffff;
        //   box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
        //   border-radius: 32px;
        // }

        // .container_right {
        //   width: 296px;
        //   height: 560px;
        //   background: #ffffff;
        //   box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
        //   border-radius: 32px;
        // }
    }
</style>


// WEBPACK FOOTER //
// GuojiApplyIndex.vue?0783fc66